import React from 'react'

import bg from '../../Assets/Images/bg.jpg'

const LastBanner = () => {
    return (
        <>
            <div className="bg-light">

                <div className="bg">
                    <div className="contaier text-center py-5">
                        <div className="row">
                            <div className="col">
                                <h2 className='fw-semibold'>
                                    Earning online has not been easier
                                </h2>
                                <h4 className='fw-semibold'>
                                    Get in touch with us

                                </h4>
                                <p className='mb-0'>
                                    Email: <span className='text-primary'>
                                        popgop.pk@gmail.com
                                    </span>
                                </p>
                                <p>
                                    Phone: <span className="text-primary">
                                        0300 1853666
                                    </span>
                                </p>

                                <button className=" px-5 py-2 btn btn-primary">
                                    Sign Up Now
                                </button>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="container ">
                    <div className="row">
                        <div className="col py-5">
                            <h3 className='text-center fw-semibold'>
                                Earn Money Online In Pakistan
                            </h3>

                            <p>
                                The internet has transformed people’s lives and is playing a key role in the daily lives of global population. People go online for almost everything now, from studying to making traveling plans to shopping online. With such widespread use of the Internet nowadays, it is no wonder that online earning methods are becoming popular and are being utilized by many to earn money through the internet. If you want to make money online in Pakistan, affiliate marketing is one of the best options available to you.
                            </p>
                            <br />
                            <p>
                                Affiliate marketing is a method of earning online through promoting someone else’s products or business. It is centered around the sharing of revenues. Affiliate marketers earn a commission if customers purchase as a result of their marketing efforts. Businesses that have products to sell and wish to generate more revenue offer financial incentive to affiliates to earn by marketing their products or business. The affiliate will attempt to promote the product to the customer on the medium the affiliate finds most convenient and appropriate
                            </p>

                            <br />

                            <p>

                                When you sign up for affiliate program, you will get a personalized affiliate link containing a unique code at the end. Our affiliate program uses this code to keep track of the customers that you have directed to our website. Another great part about affiliate marketing is that you don’t even need to have your own website, you can post your affiliate link on your social media pages or accounts or in the comments sections of different social media pages or blogs.
                            </p>
                            <br />

                            <p>
                                Goto affiliate program is one of the best affiliate programs in Pakistan if you are seriously thinking about entering this field. The sign up process is really quick and easy and can be done in just a few minutes. After filling in your registration form, you just log into your account, get the tracking links for your website and/or social media pages and start promoting. The best part about affiliate marketing with Goto is that there is a huge variety of available products for you to pick from. With Goto website displaying more than 500,000 items, it is very tough for you to run out of products to market and you can choose the ones you like the best. You can also view the results of your marketing efforts from the affiliate panel provided to you on Sign Up. Your commission is paid to you every month.

                            </p>

                            <br />

                            So, if you really wish to earn money online in Pakistan without investment, Goto is bringing one of the most amazing affiliate programs in Pakistan right within your easy access. Try your hand at affiliate marketing with Goto and earn great commissions for yourself. The system of paying commission is quite transparent at Goto and the registration page gives the details for the commission being paid on various product categories, so there is no ambiguity when you decide to register and work as an affiliate marketer for this online store. You will not think about earning online with any other website and will decide to stick with Goto due to the amazing experience you will have earning as an affiliate marketer here.
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default LastBanner